// extracted by mini-css-extract-plugin
export var active = "Menu-module--active--9c379";
export var container = "Menu-module--container--68959";
export var item = "Menu-module--item--cde1b";
export var largMenuContainer = "Menu-module--largMenuContainer--95a60";
export var title = "Menu-module--title--d33e1";